import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Company Info */}
          <div className="space-y-5 mb-4">
  <Link to="/" className="flex items-center">
    <img 
      src="/images/logo.png"
      alt="EVERKAST NZ" 
      className="h-12 md:h-14 w-auto object-contain brightness-0 invert"
      onError={(e) => e.target.style.display = 'none'}
    />
  </Link>


            <p className="text-sm text-slate-400 leading-relaxed">
              Premium decorative and protective paints designed for durability, performance, and long-lasting finish.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base font-semibold mb-5 text-white">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { name: "Home", path: "/" },
                { name: "About", path: "/about" },
                { name: "Interior Paints", path: "/category/interior-paints" },
                { name: "Exterior Paints", path: "/category/exterior-paints" },
                { name: "Primers & Base Layers", path: "/category/primers-base-layers" },
                { name: "Specialty Finishes", path: "/category/specialty-finishes" }
              ].map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path} 
                    className="text-slate-400 hover:text-white transition-all duration-200 text-sm hover:translate-x-1 inline-block"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-base font-semibold mb-5 text-white">Resources</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/datasheets" className="footer-link">Technical Datasheets</Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link">Contact Us</Link>
              </li>
              <li>
                <Link to="/request-quote" className="footer-link">Request Quote</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-base font-semibold mb-5 text-white">Contact</h3>
            <ul className="space-y-4">

              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-slate-500 mt-0.5" />
                <a href={`mailto:${companyInfo.contact.email}`} className="footer-link">
                  {companyInfo.contact.email}
                </a>
              </li>

              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-slate-500 mt-0.5" />
                <a href={`tel:${companyInfo.contact.phone}`} className="footer-link">
                  {companyInfo.contact.phone}
                </a>
              </li>

              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-slate-500 mt-0.5" />
                <span className="text-slate-400 text-sm leading-relaxed">
                  {companyInfo.contact.address}
                </span>
              </li>

            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-14 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">

            <p className="text-sm text-slate-500 text-center md:text-left">
              © {new Date().getFullYear()} EVERKAST NZ Limited. All rights reserved.
            </p>

            <p className="text-sm text-slate-500">
              Built for performance & durability
            </p>

          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;